import React from 'react';
import AuthPage from '../components/AuthPage';

const Register = () => <AuthPage mode="register" />;

export default Register;
